import {CrudCollection, Graphql} from '@hc/graphql'
import { reactive, toRefs} from 'vue'

export interface UseCrudObjectParams {
  collection: string | CrudCollection
  id: number | string
}

export function useCrudObject(params: UseCrudObjectParams){
  const objectCollection = typeof params.collection == 'object' ? params.collection : Graphql.collection(params.collection)
  const state = reactive({
    object: null,
    objectLoading: false,
  })
  const props = {
    objectId: params.id,
  }
  const methods = {
    async loadObject(silent = false){
      if(!silent) state.objectLoading = true
      state.object = await objectCollection.find(params.id)
      if(!silent) state.objectLoading = false
    }
  }
  return {
    ...props,
    ...toRefs(state),
    ...methods,
    objectCollection,
  }
}
